import { Settings } from 'luxon';

Settings.defaultLocale = 'de-De';
export const localeId: string = 'de-DE';
export const matLocaleId: string = 'de-DE';

export const defaultDateFormatOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const defaultDateFormat: string = 'dd.MM.yyyy';

export const defaultDateTimeFormat: string = 'yyyy-MM-dd HH:mm:ss';
